import React from 'react';
import '../less/business-list.less';
import Banner from '../../../../../auxiliary-components/shared/Banner';
import banner_img from '../img/banner_img.png';
import businessList from '../enums/business_list_data.json';
import businessCreditsList from '../enums/business_list_credits_data.json';
import clearBR from "utils/clearBR";
import { openAccountBusinessFOP } from '../../../../../services/urls/urls';
import CardOrderModal from '../../../../../auxiliary-components/CardOrderModal';

export default function template() {
    const isMobile = this.isViewportMobile(),
    isMobileWithoutUtmMarks = !this.state.withUtmMarks && isMobile,
    modal = this.state.showModal ? <CardOrderModal closeModal={this.toggleModal} product={"fop"} isOpen={this.state.showModal} isBusiness={true}/> : '';
    const primaryBtnHandlersMap = {
      openFopAccount: isMobileWithoutUtmMarks ? () => window.open(openAccountBusinessFOP, '_blank') : this.toggleModal,
      openYuoAccount: () => window.open('/business/yuo?open-account', '_self'),
    };

    const businessItems = businessList.items.map(item => {
    const text = isMobile ? clearBR(this.l10n(item.text)) : this.l10n(item.text);
    const { primaryBtn } = item;
    const primaryBtnHandler = primaryBtn ? primaryBtnHandlersMap[primaryBtn.handler] : null;
    return (
      <div key={item.name} className={`business-list-item`}>
        <div className='left-side left-side-business-list'>
          <h2 className="title" dangerouslySetInnerHTML={{ __html:this.l10n(item.title)}}></h2>
          <div className={`text`} dangerouslySetInnerHTML={{ __html: text}}></div>
        </div>
        <div className='right-side'>
          <div className='right-side-advantages'>
            <div className='right-side-advantages-item'>
              <div className="right-side-advantages-item-title" dangerouslySetInnerHTML={{ __html: this.l10n(item.advantage_title_1)}}></div>
              <div className={`right-side-advantages-item-text`} dangerouslySetInnerHTML={{ __html: this.l10n(item.advantage_text_1)}}></div>
            </div>
            <div className='right-side-advantages-item'>
              <div className="right-side-advantages-item-title" dangerouslySetInnerHTML={{ __html: this.l10n(item.advantage_title_2)}}></div>
              <div className={`right-side-advantages-item-text`} dangerouslySetInnerHTML={{ __html: this.l10n(item.advantage_text_2)}}></div>
            </div>
            <div className='right-side-advantages-item'>
              <div className="right-side-advantages-item-title" dangerouslySetInnerHTML={{ __html: this.l10n(item.advantage_title_3)}}></div>
              <div className={`right-side-advantages-item-text`} dangerouslySetInnerHTML={{ __html: this.l10n(item.advantage_text_3)}}></div>
            </div>
          </div>
          {primaryBtn ? (
            <div className='business-list-item__btns'>
              <button className={`btn ${item.link.substring('/business/'.length)}`} onClick={primaryBtnHandler}>
                {this.l10n("FOP_ACCOUNTS_OPEN_ACCOUNT")}
              </button>
              <button className='btn btn-link' onClick={() => window.open(item.link, '_self')}>
                {this.l10n("FOP_ACCOUNTS_NEWS_MORE")}
              </button>
            </div>
          ) : (
            <button className={`btn ${item.link.substring('/business/'.length)}`} onClick={() => window.open(item.link, '_self')}>
              {this.l10n("FOP_ACCOUNTS_NEWS_MORE")}
            </button>
          )}
        </div>
      </div>
    )
  });
  const businessCreditsItems = businessCreditsList.items.map(item => {
    const text = isMobile ? clearBR(this.l10n(item.text)) : this.l10n(item.text);
    return (
      <div key={item.name} className={`business-list-item`}>
        <div className='left-side left-side-business-list'>
          <h2 className="title" dangerouslySetInnerHTML={{ __html:this.l10n(item.title)}}></h2>
          <div className={`text`} dangerouslySetInnerHTML={{ __html: text}}></div>
        </div>
        <div className='right-side'>
          <div className='right-side-advantages'>
            <div className='right-side-advantages-item'>
              <div className="right-side-advantages-item-title" dangerouslySetInnerHTML={{ __html: this.l10n(item.advantage_title_1)}}></div>
              <div className={`right-side-advantages-item-text`} dangerouslySetInnerHTML={{ __html: this.l10n(item.advantage_text_1)}}></div>
            </div>
            <div className='right-side-advantages-item'>
              <div className="right-side-advantages-item-title" dangerouslySetInnerHTML={{ __html: this.l10n(item.advantage_title_2)}}></div>
              <div className="right-side-advantages-item-text" dangerouslySetInnerHTML={{ __html: this.l10n(item.advantage_text_2)}}></div>
            </div>
            <div className='right-side-advantages-item'>
              <div className="right-side-advantages-item-title" dangerouslySetInnerHTML={{ __html: this.l10n(item.advantage_title_3)}}></div>
              <div className={`right-side-advantages-item-text`} dangerouslySetInnerHTML={{ __html: this.l10n(item.advantage_text_3)}}></div>
            </div>
          </div>
          <button className={`btn ${item.link.substring('/business/'.length)}`} onClick={() => window.open(item.link, '_self')}>
            {this.l10n("FOP_ACCOUNTS_NEWS_MORE")}
          </button>
        </div>
      </div>
    )
  });

    return (
        <div className='module-services'>
            <div className='credit-limit-module'>
                <Banner
                    img={banner_img}
                    text={'BUSINESS_MAIN_BANNER_MESSAGE'}
                    textMob={'BUSINESS_MAIN_BANNER_MESSAGE'}
                    title={'BUSINESS_MAIN_BANNER_TITLE'}
                    page={'business-list'}
                    isMobile={isMobile}
                ></Banner>
                <div className='content'>
                  <div className='business-list'>
                    {businessItems}
                  </div>
                  <div id='credits-anchor'></div>
                  <div className='business-list'>
                    <div className='business-list-title'>{this.l10n('BUSINESS_MAIN_CREDITS_TITLE')}</div>
                    {businessCreditsItems}
                  </div>
                </div>
            </div>
          {modal}
        </div>
    );
}
